<div class="cmn-dialog-card-view">
    <button class="dialog-close-btn" *ngIf="!content.hideCloseBtn" (click)="closeDialog()">
        <img class="cross-icon" src="assets/svg/icons/cross.svg" />
    </button>

    <div class="dialog-header">
        <span class="icon dialog-header-icon" *ngIf="content?.image" [svgIcon]="content?.image"></span>
        <h1 *ngIf="!content?.html" class="dialog-header-title-gradient mb-10">{{ content.title }}</h1>
        <h1 *ngIf="content?.html" class="dialog-header-title-gradient mb-10" [innerHTML]="contentTitle"></h1>
    </div>

    <mat-dialog-actions>
        <div class="dialog-actions">
            <div class="dialog-actions-btn">
                <button type="button" class="primary-fill-btn btn-w100" (click)="onConfirmClick()">
                    {{ content?.confirmButtonName || "Confirm" }}
                </button>
                <button type="button" class="primary-outline-btn btn-w100" (click)="onCancelClick()">
                    {{ content?.cancelButtonName || "Cancel" }}
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</div>
